import React, { useState } from 'react'
import NewExamTab from './NewExamTab'
import ReviewList from './ReviewList'
import ReviewTab from './ReviewTab'
import ApprovedList from './ApprovedList'

const ExamTabs = () => {

    const [activeIndex, setActiveIndex] = useState(1);
    const handleClick = (index) => setActiveIndex(index);
    const checkActive = (index, className) => activeIndex === index ? className : "";

    const tabs = [
        {
            id: 1,
            title: 'Add New',
            content: <NewExamTab/>,
        },

        {
            id: 2,
            title: 'Review List',
            content: <ReviewList/>,
        },

        {
            id: 3,
            title: 'Review',
            content: <ReviewTab/>,
        },

        {
            id: 4,
            title: 'Approved List',
            content: <ApprovedList/>,
        },
    ]
  return (
    <div className='flex flex-col px-8'>

    <div className='flex justify-between bg-white shadow-lg px-6 py-4 rounded-lg'>
    {tabs.map(tabs => (
        <button 
        key={tabs.id}
        onClick={() => handleClick(tabs.id)}
        className={`${checkActive(
            tabs.id,
            "border-b-4 border-blue-500 text-blue-500"
        )} hover:text-blue-500`}
        >
        {tabs.title}</button>))}
    </div>

    <div>
    {tabs.map(tabs => (
        <div
        key={tabs.id}
        className={`flex flex-col py-10 panel ${checkActive(
            tabs.id,
            "active"
        )}`}
        >{tabs.content}</div>))}
    </div>
        
    </div>
    
  )
}

export default ExamTabs
